import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  expand = false;

  expandedMenu: any = null;
  role: any = 'ADMIN'
  constructor() {
    this.role = localStorage.getItem('_identity_role');
  }

  ngOnInit(): void {
  }

  toggleMenuItem(target: string): void {
    if (this.expandedMenu === target) {
      this.expandedMenu = null;
    } else {
      this.expandedMenu = target;
    }
  }
  

}
